/**
 * Community MFE Route
 * 
 * Loads and renders the Community MFE with error boundary protection.
 * 
 * @module components/mfe/CommunityRoute
 */

import React from 'react';
import { MFELoader } from './MFELoader';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const CommunityRoute: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <ErrorBoundary onReset={() => window.location.reload()}>
      <MFELoader
        mfeName="Community"
        accessToken={token}
        refUserId={user.id}
        onLogout={logout}
      />
    </ErrorBoundary>
  );
};

